import { connect } from "react-redux";
import { formValueSelector } from "redux-form";

export default function withFieldsFromForm(form, fields = []) {
  return Component =>
    connect(state => {
      const selector = formValueSelector(form);
      const stateObj = {};
      fields.forEach(f => {
        stateObj[f] = selector(state, f);
      });
      return stateObj;
    })(Component);
}

export function withFieldsFromFormWithKeys(form, fields = {}) {
  return Component =>
    connect(state => {
      const selector = formValueSelector(form);
      const stateObj = {};
      Object.keys(fields).forEach(f => {
        stateObj[f] = selector(state, fields[f]);
      });
      return stateObj;
    })(Component);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/withFieldsFromForm.jsx